

















































































import {
  ref,
  defineComponent,
  PropType,
  computed,
  watchEffect,
} from "@nuxtjs/composition-api";

import { Product } from "~/modules/catalog/product/types";
import { changeImage } from "~/helpers";
import { getName as getProductName } from "~/modules/catalog/product/getters/productGetters";
import ProductOptions from "./ProductOptions.vue";
import ProductInStore from "./ProductInStore.vue";
import { Logger } from "~/helpers/logger";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { getFirstImageByVariants, setSizeProductList } from "~/modules/catalog/category/helpers";
import { getPrices } from "~/modules/catalog/product/getters/productGetters";

export default defineComponent({
  name: "CheckStockInStore",
  components: {
    ProductOptions,
    ProductInStore,
    SkeletonLoader,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    availableOptions: {
      type: Object as PropType<{ size: any[]; color: any[] }>,
      default: null,
    },
    dataCheckOptionInstock: {
      type: Array as PropType<any[]>,
      required: true,
    },
    parentSku: {
      type: String as PropType<string>,
      default: "",
    },
    configurableOptions: {
      type: Array as PropType<any[]>,
      required: true,
    },
    optionSelected: {
      type: Object as PropType<{ size: any; color: any }>,
    },
  },
  setup(props) {
    const productImage = ref("");
    const showColorAlert = ref(true);
    const showSizeAlert = ref(true);

    1;

    const selectedOption = ref({
      size: props.optionSelected?.size ?? null,
      color: props.optionSelected?.color ?? null,
    });

    const updateSelectedOption = (attributeOption: any) => {
      if (attributeOption.type === "color") {
        selectedOption.value.color = attributeOption;
        showColorAlert.value = false;
        if (checkSizeByVariants(
          selectedOption.value.size,
          attributeOption
        )) {
          // Nếu có size tương ứng với màu đã chọn, không cần hiển thị cảnh báo
          showSizeAlert.value = false;
        } else {
          // Nếu không có size tương ứng, hiển thị cảnh báo
          selectedOption.value.size = null;
          showSizeAlert.value = true;
        }
      } else if (attributeOption.type === "size") {
        selectedOption.value.size = attributeOption;
        showSizeAlert.value = false;
      }
    };

    const variants = computed(() => {
      return props.product?.configurable_children ?? [];
    });

    const checkSizeByVariants = (sizeOption, colorOption) => {
      if (props.availableOptions.color.length > 0 && !colorOption) return false;
      if (!variants.value || !variants.value.length) return false;
      if (props.availableOptions.color.length == 0){
        return true;
      }

      const hasMatchingSize = variants.value.some(
        (variant) =>
          variant?.size == sizeOption?.value_index &&
          variant?.color == colorOption?.value_index
      );
      return hasMatchingSize;
    };

    const getFirstImageBySelectedOptions = computed(() => {
      if (selectedOption.value.color) {
        return getFirstImageByVariants(
          selectedOption.value.color,
          props?.product?.configurable_children
        );
      }

      // Trả về ảnh mặc định nếu không tìm thấy
      return props.product && props.product.media_gallery && props.product.media_gallery.length > 0
        ? setSizeProductList(props.product.media_gallery?.[0].image)
        : setSizeProductList(props.product?.thumbnail_url);
    });

    return {
      changeImage,
      getProductName,
      updateSelectedOption,
      selectedOption,
      productImage,
      showColorAlert,
      showSizeAlert,
      variants: props.product?.configurable_children || [],
      getFirstImageBySelectedOptions,
      getPrices,
    };
  },
});
